import { c as _c } from "react/compiler-runtime";
import type { RestoreAccount } from '@repo/api-gw-sdk';
import { AccountState, Provider } from '@repo/api-gw-sdk';
import { useRestoreAccounts } from '@/app/(dashboard)/settings/restore-accounts/useRestoreAccounts';
import { createCloudProviderCondition } from '@/components/cloudProviders/createCloudProviderCondition';
import { Loader } from '@/components/shared/loader';
import { useDAL } from '@/contexts/useDAL';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { getByovPolicyJson } from './byovPolicyUtils';
import { CopyableCode } from '../shared/copyableCode';
export const VaultOwnBucketCopyableAllAccountsPolicy = t0 => {
  const $ = _c(7);
  const {
    bucketName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createCloudProviderCondition([Provider.Aws]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: restoreAccountsBody,
    isLoading: restoreAccountsLoading
  } = useRestoreAccounts(t1);
  if (restoreAccountsLoading) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Loader />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== restoreAccountsBody?.accounts) {
    t2 = restoreAccountsBody?.accounts ?? [];
    $[2] = restoreAccountsBody?.accounts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== bucketName || $[5] !== t2) {
    t3 = <VaultOwnBucketCopyablePolicy bucketName={bucketName} restoreAccounts={t2} />;
    $[4] = bucketName;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const VaultOwnBucketCopyablePolicy = ({
  bucketName,
  restoreAccounts
}: {
  bucketName: string;
  restoreAccounts: RestoreAccount[];
}) => {
  const dal = useDAL();
  const {
    dlsgFrontend
  } = useFeatureFlags();
  const {
    data: scanningAccounts,
    isLoading: isLoadingScanningAccounts
  } = dal.cloudAccounts.scanning.useList();
  if (isLoadingScanningAccounts) {
    return <Loader />;
  }
  const scanningAccountIds = (scanningAccounts?.accounts ?? []).filter(account => account.cloudProvider === Provider.Aws && account.state === AccountState.ACCOUNT_STATE_CONNECTED)
  // The primary scanning account is created first; sort by creation time so
  // index 0 is the primary, where the DLSG/s3-proxy roles are granted.
  .sort((a, b) => (a.createdTime ? new Date(a.createdTime).getTime() : 0) - (b.createdTime ? new Date(b.createdTime).getTime() : 0)).map(account_0 => account_0.providerAccountId);
  return <CopyableCode title='policy.json' code={getByovPolicyJson(bucketName, scanningAccountIds, dlsgFrontend, restoreAccounts)} maxHeight='320px' blur={!bucketName} />;
};